import React from "react";
import AdmissionRequirements from "../components/Courses/InformationTechnology/AdmissionRequirements";
import ITProgramsCard from "../components/Courses/InformationTechnology/ExploreProgramsIT";
import InformationTechnologyHeader from "../components/Courses/InformationTechnology/InformationTechnologyHeader";
import ITCareerSkillsSection from "../components/Courses/InformationTechnology/ITCareerSkills";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";

const InfoTech = () => {
  return (
    <div>
      <Navbar />
      <InformationTechnologyHeader />
      <ITCareerSkillsSection />
      <ITProgramsCard />
      <AdmissionRequirements />
      <FullScreenImage />
      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default InfoTech;
